import React from 'react';
import PropTypes from 'prop-types';

const ModalConection = props => {
  const { isHide, handleHideModal, handlePropagation, handleModal } = props;
  return (
    <div className={`${isHide ? 'modal-conection-container' : 'hide-modal'}`} onClick={handleModal}>
      <div className="modal-conection-wraper" onClick={handlePropagation}>
        <span className="fa-stack list-icon-create fa-1x modal-close" onClick={handleModal}>
          <i className="fas fa-circle fa-stack-1x " />
          <i className="fas fa-times fa-stack-1x fa-inverse" />
        </span>
        <h2>
          {props.language.account.accountAssigment.withoutConnection}
          {props.language.account.accountAssigment.anonymousDriver}
        </h2>
        <div className="fecha">
          <span>fecha</span>
          <div className="col-75">
            <select id="country" name="country">
              <option value="australia">Australia</option>
              <option value="canada">Canada</option>
              <option value="usa">USA</option>
            </select>
          </div>
        </div>
        <div className="tbl-header" onClick={handlePropagation}>
          <table cellPadding="0" cellSpacing="0" border="0">
            <thead>
              <tr>
                <th className="left-style">
                  <span>
                    <a href="#">{props.language.account.accountAssigment.vehicleCode}</a>
                    <i className="fas fa-arrows-alt-v assignment" />{' '}
                  </span>
                </th>
                <th>
                  <span>
                    <a href="#"> {props.language.account.accountAssigment.categorie}</a>
                    <i className="fas fa-arrows-alt-v assignment" />
                  </span>
                </th>
                <th className="right-style">
                  <span>
                    <a href="#"> {props.language.account.accountAssigment.hour}</a>
                    <i className="fas fa-arrows-alt-v assignment" />
                  </span>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div className="tbl-content">
          <table cellPadding="0" cellSpacing="0" border="0">
            <tbody>
              {props.datos &&
                props.datos.map((item, index) => {
                  if (!item.isAssigned) {
                    return (
                      <tr key={index + 1}>
                        <td className="left-style">{item.vehicleAlias}</td>
                        <td>{item.categorie ? item.categorie : 'sin dato'}</td>
                        <td className="right-style">{item.to ? item.to : 'sin dato'}</td>
                      </tr>
                    );
                  }
                })}
            </tbody>
          </table>
        </div>
        <div className="total">
          <span>Total:</span>
          <span>
            {props.datos &&
              props.datos.filter(item => {
                return !item.isAssigned;
              }).length}
          </span>
        </div>
      </div>
    </div>
  );
};

ModalConection.propTypes = {};
export default ModalConection;



// WEBPACK FOOTER //
// ./source/client/components/assignment_list/modalConection.jsx